module.exports = __webpack_public_path__ + "static/media/header.420f6705.webp";